import { createDialogOptionActionListener } from '../../Inamove/Components/Dialog/DialogOption'
import { createInteractableObjectListener } from '../../Inamove/Components/InteractableObject'
import Level, { levelActionCreator, LevelActionsAction } from '../../Inamove/Components/Level'
import Video from '../../Inamove/Components/Video/Video'
import CinematicContainer from '../../Inamove/Containers/CinematicContainer/CinematicContainer'
import Config from '../../Inamove/Containers/Config'
import GameSceneContainer from '../../Inamove/Containers/GameSceneContainer/GameSceneContainer'
import InventoryContainer from '../../Inamove/Containers/InventoryContainer/InventoryContainer'
import LoadingContainer from '../../Inamove/Containers/LoadingContainer/LoadingContainer'
import AudioController from '../../Inamove/Controllers/AudioController'
import LevelController from '../../Inamove/Controllers/LevelController'
import LoadingController from '../../Inamove/Controllers/LoadingController'
import dispatch from '../../Inamove/Utility/dispatchAction'

export default async function () {
    InventoryContainer.clean()
    CinematicContainer.hide()
    GameSceneContainer.hide()
    LoadingController.reset()
    LoadingContainer.show()

    const V8 = new Video(Config.CINEMATIC_PATH + 'V8' + Config.VIDEO_FILE_EXT)
    CinematicContainer.setVideo(V8)
    LoadingController.addToQueue(V8)

    const level = await LevelController.loadLevel('level4')

    await AudioController.addAllToLoadingQueue()

    createInteractableObjectListener('empfangsdame', async () => {
        level.stopGame(true)
        await level.startDialog('D2')
        level.startGame()
    })

    await LoadingController.processQueue()
    await LoadingContainer.clickStart()

    GameSceneContainer.hide()
    InventoryContainer.hide()
    CinematicContainer.show()
    LoadingContainer.hide()

    await CinematicContainer.play()

    CinematicContainer.hide()
    GameSceneContainer.show()
    LevelController.startLevel('level4')

    createDialogOptionActionListener((option) => {
        if (option.action?.eventId === 'dialog-ende') {
            dispatch(levelActionCreator(level, LevelActionsAction.stop))
        }
    })

    return new Promise<void>((resolve) => {
        addEventListener('Level', (event) => {
            // @ts-ignore
            const action: LevelActionsAction = event.detail.action
            // @ts-ignore
            const level: Level = event.detail.level

            if (action === LevelActionsAction.stop && level.id === 'level4') {
                resolve()
                level.destroy()
            }
        })
    })
}
